class MybacsGame extends HTMLElement {
  constructor() {
    super();
    const template = document.getElementById('gut-hero-template');
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.appendChild(template.content.cloneNode(true));

    this.canvas = shadow.getElementById("gameCanvas");
    this.ctx = this.canvas.getContext("2d");

    this.hero = { x: 50, y: 300, width: 40, height: 40, velocityY: 0, gravity: 1.5, jumpPower: -26 };
    this.obstacles = [];
    this.score = 0;
    this.gameOver = false;
    this.framesSinceLastObstacle = 0;
    this.minFramesBetweenObstacles = 70;
    this.speed = 5;
    this.shield = false;
    this.spacePresses = 0;

    this.images = {
      pizza: new Image(),
      shake: new Image(),
      burger: new Image(),
      probiotic: new Image(),
      hero: new Image(),
    };

    this.images.pizza.src = this.dataset.pizza;
    this.images.shake.src = this.dataset.shake;
    this.images.burger.src = this.dataset.burger;
    this.images.probiotic.src = this.dataset.probiotic;
    this.images.hero.src = this.dataset.hero;

    this.loaded = 0;
    Object.values(this.images).forEach(img => {
      img.onload = () => {
        this.loaded++;
        if (this.loaded === 5) this.gameLoop();
      }
    });

    this.renderLeaderboard();

    this.shadowRoot.getElementById("submitBtn").addEventListener("click", () => {
      this.submitScore();
    });

    document.addEventListener("keydown", e => {
      if (e.code === "Space") {
        e.preventDefault();

        this.handleJumpOrRestart();
      }
    });

    document.addEventListener("touchstart", () => this.handleJumpOrRestart());
  }

  drawHero() {
    if (this.shield) {
      this.ctx.shadowColor = '#00FFFF';
      this.ctx.shadowBlur = 20;
    }
    this.ctx.drawImage(this.images.hero, this.hero.x, this.hero.y, this.hero.width, this.hero.height);
    this.ctx.shadowBlur = 0;
  }

  drawObstacle(o) {
    const img = o.good ? this.images.probiotic : this.images[o.type];
    this.ctx.drawImage(img, o.x, o.y, o.width, o.height);
  }

  updateObstacles() {
    this.framesSinceLastObstacle++;
    this.obstacles.forEach(o => o.x -= this.speed);

    if (this.framesSinceLastObstacle > this.minFramesBetweenObstacles && Math.random() < 0.05) {
      const isGood = Math.random() < 0.15;
      const type = ['pizza', 'shake', 'burger'][Math.floor(Math.random() * 3)];
      const size = 20 + Math.floor(Math.random() * 30);
      const y = 300 + (30 - size);
      this.obstacles.push({ x: this.canvas.width, y, width: size, height: size, good: isGood, type: isGood ? null : type });
      this.framesSinceLastObstacle = 0;
    }
    this.obstacles = this.obstacles.filter(o => o.x + o.width > 0);
  }

  checkCollisions() {
    this.obstacles.forEach((o, i) => {
      if (this.hero.x < o.x + o.width && this.hero.x + this.hero.width > o.x && this.hero.y < o.y + o.height && this.hero.y + this.hero.height > o.y) {
        if (o.good) {
          this.score += 10;
          this.shield = true;
          this.obstacles.splice(i, 1);
        } else if (this.shield) {
          this.shield = false;
          this.obstacles.splice(i, 1);
        } else {
          this.gameOver = true;
          this.shadowRoot.getElementById("leaderboard-form").style.display = "block";
          this.shadowRoot.getElementById("restartPrompt").style.display = "block";
        }
      }
    });
  }

  drawScore() {
    this.ctx.fillStyle = "#000000";
    this.ctx.font = "20px Arial";
    this.ctx.fillText("Score: " + this.score, 10, 30);
  }

  gameLoop() {
    if (this.gameOver) {
      this.ctx.fillStyle = "#EF4123";
      this.ctx.font = "40px Arial";
      this.ctx.fillText("Game Over!", 300, 200);
      return;
    }

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.hero.velocityY += this.hero.gravity;
    this.hero.y += this.hero.velocityY;
    if (this.hero.y > 300) { this.hero.y = 300; this.hero.velocityY = 0; }

    this.updateObstacles();
    this.checkCollisions();

    this.drawHero();
    this.obstacles.forEach(o => this.drawObstacle(o));
    this.drawScore();

    if (this.score > 0 && this.score % 25 === 0) {
      this.speed = 5 + Math.floor(this.score / 25);
    }

    requestAnimationFrame(() => this.gameLoop());
  }

  handleJumpOrRestart() {
    if (!this.gameOver && this.hero.y === 300) this.hero.velocityY = this.hero.jumpPower;
    if (this.gameOver) {
      this.spacePresses++;
      if (this.spacePresses >= 2) this.resetGame();
    }
  }

  resetGame() {
    this.hero.y = 300;
    this.hero.velocityY = 0;
    this.obstacles = [];
    this.score = 0;
    this.gameOver = false;
    this.speed = 5;
    this.shield = false;
    this.spacePresses = 0;
    this.shadowRoot.getElementById("leaderboard-form").style.display = "none";
    this.shadowRoot.getElementById("restartPrompt").style.display = "none";
    this.gameLoop();
  }

  async renderLeaderboard() {
    console.log('renderLeaderboard');
    const leaderboard = this.shadowRoot.getElementById("leaderboardTable");
    let leaders = await this.getLeaderboard();

    if (leaderboard) {
      leaderboard.innerHTML = "";

      leaders.forEach(leader => {
        const p = document.createElement('p');

        p.innerHTML = `<span>${leader.name}</span><span>${leader.score}</span>`;
        leaderboard.appendChild(p);
      })
    }
  }

  async submitScore() {
    const name = this.shadowRoot.getElementById("playerName").value;

    this.shadowRoot.getElementById("confirmation").innerText = '';

    if (!name || this.score < 10) {
      this.shadowRoot.getElementById("confirmation").innerText = `Your score is 0, you can't submit this value.`;

      return;
    }

    let result = await this.sendScore({
      name,
      score: this.score,
      customer_id: this.dataset.customer
    });

    this.shadowRoot.getElementById("confirmation").innerText = `Thanks, ${name}! Your score of ${this.score} was submitted.`;
    this.shadowRoot.getElementById("leaderboard-form").style.display = "none";

    this.renderLeaderboard();
    this.clearDataAfterSubmit();
  }

  clearDataAfterSubmit() {
    this.shadowRoot.getElementById("confirmation").innerText = '';
    this.shadowRoot.getElementById("playerName").value = '';
  }

  sendScore(data) {
    return fetch(this.getApiUrl() + '/submit-score', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then((data) => console.log(data));
  }

  getLeaderboard() {
    return fetch(this.getApiUrl() + '/leaderboard')
      .then((res) => res.json());
  }

  getApiUrl() {
    return 'https://api-4rbjibbp4q-uc.a.run.app';
  }
}

customElements.define('mybacs-game', MybacsGame);
